import { useState, useEffect } from "react";
import { Select, Loader } from "@mantine/core";
import { fetchCustomers, Customer } from "../../services/customerService";

interface CustomerSelectProps {
  value: string | null;
  onChange: (value: string | null) => void;
}

export function CustomerSelect({ value, onChange }: CustomerSelectProps) {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadCustomers = async () => {
      setLoading(true);
      try {
        const data = await fetchCustomers();
        setCustomers(data);
      } catch (error) {
        console.error("Failed to fetch customers:", error);
      } finally {
        setLoading(false);
      }
    };

    loadCustomers();
  }, []);

  const data = customers.map((c) => ({
    value: c.customerId,
    label: `${c.customerName} (${c.customerId})`,
  }));

  return (
    <Select
      placeholder="顧客を選択"
      data={data}
      value={value}
      onChange={onChange}
      searchable
      clearable
      size="xs"
      nothingFoundMessage="顧客が見つかりません"
      rightSection={loading ? <Loader size={16} /> : null}
      style={{ width: "100%" }}
    />
  );
}
